import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  duration,
  size,
} from '@twistopayments/design-system/styles'

export const eshop = (theme: Theme) => css`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${theme.palette.background.accent};
  display: block;
  flex-shrink: 0;
  scroll-snap-align: center;
  grid-row: span 2;
  overflow: hidden;

  &::after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  ${breakpoint.up('sm')} {
    min-height: 7rem;
    grid-row: span 2;
    grid-column: span 2;
  }

  &:focus {
    outline: 2px solid ${theme.palette.primary.maxContrast};
  }
`

export const compact = (theme: Theme) => css`
  height: 100%;
  max-height: ${size[60]};
  border: 1px solid #e0e2e5;
  border-radius: ${theme.borderRadius.sm};

  ${breakpoint.up('sm')} {
    max-height: unset;
  }
`

export const content = css`
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;

  &:hover .eshop__background {
    transform: scale(1.2);
  }
`

export const backgroundWrap = css`
  width: 100%;
  height: 100%;
  transition: transform ${duration.gentle}ms ease;
`

export const overlay = (theme: Theme) => css`
  &::before {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${theme.palette.overlay.accent};
    opacity: 0.6;
    width: 100%;
    height: 100%;
  }
`

export const foreground = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 85%;
  max-height: 65%;
  object-fit: contain;

  ${breakpoint.up('sm')} {
    max-width: 70%;
    max-height: 70%;
  }
`

export const background = css`
  max-width: ${size[120]};
  min-width: 100%;
  min-height: 100%;
`

export const logo = css`
  height: 100%;
  width: 100%;
  object-fit: contain;
`

export const name = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: ${size[60]};
  padding: ${size[8]};
  color: ${theme.palette.text.title};
  text-align: center;
  overflow-wrap: anywhere;
`
